const state = {
  isShowRouterViewPage: false
}

const getters = {
}

const actions = {
}

const mutations = {
  showRouterViewPage(state) {
    state.isShowRouterViewPage = true
  },
  hideRouterViewPage(state) {
    state.isShowRouterViewPage = false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/mainPageManage.js